export default __webpack_public_path__ + "media/images/twitter-89be84020598dc5ba683319318954e83.svg";